import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import { FaChalkboardUser } from "react-icons/fa6";
import TrainingCourses from "./index";
import { MODULE_TRAINING_MY_COURSES, MODULE_TRAINING_MOD } from "variables/constants";
import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";
import TrainingModules from "./index";
import ViewTrainingModule from "../training-modules/view";

const trainingCourseRoutes = [	
	generateCRUDRoutes({
		mainTitle: "My Courses",
		basePath: "training-courses",
		mainComponent: <TrainingCourses />,
	    layout: "/console",	   
	    icon: <FaChalkboardUser className="icon-item" />,
	    subTitle:"Training Courses",
	    viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level: 5,
		moduleId: MODULE_TRAINING_MY_COURSES,
		viewSubmodules: [
			generateCRUDRoutes({
				mainTitle: "Modules",
				basePath: "training-modules",
				mainComponent: <TrainingCourses />,
				layout: "/console",	   
				subTitle:"Training Module",
				viewComponent: <ViewTrainingModule />,
				level:5,
				moduleId: MODULE_TRAINING_MOD,
			})
		],
	}),
]

export default trainingCourseRoutes;